import { Form } from 'formik';
import { EvolveBanner } from '~/components/Evolve/Banner/EvolveBanner';
import { EvolveFormButton } from '~/components/Evolve/Button/EvolveFormButton';
import { EvolveFormHero } from '~/components/Evolve/Form/Hero/EvolveFormHero';
import { EvolveSelectCard } from '~/components/Evolve/Select/Card/EvolveSelectCard';
import { EvolveSelectedFriends } from '~/components/Evolve/Selected/EvolveSelectedFriends';
import { Section } from '~/components/Page/Section/Section';
import { StickyBottom } from '~/components/Sticky/StickyBottom';
import styles from './EvolveForm.module.scss';

export const EvolveForm = () => (
  <Form className={styles.root}>
    <Section className={styles.pageSection}>
      <Section className={styles.heroSection}>
        <EvolveFormHero />
      </Section>
      <Section className={styles.bodySection}>
        <EvolveBanner />
        <EvolveSelectedFriends />
        <EvolveSelectCard />
      </Section>
    </Section>
    <StickyBottom className={styles.stickyBottom}>
      <EvolveFormButton className={styles.button} />
    </StickyBottom>
  </Form>
);
